import './framework/estilos.css';

import { Encabezado } from './encabezado';
import { Footer } from './footer';
import { Principal } from './principal';

function App() {
  return (
    <> 
      <Encabezado />   
      <Principal />
      <Footer />
    </>  
  );
}

export default App;
